module.exports = __webpack_public_path__ + "6dc79a8154dcc72f8b3554e2475128cc.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-BlackItalic.ttf
// module id = 963
// module chunks = 0